import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((cfg) => {
  const u = localStorage.getItem("q1_demo_user");
  if (u) cfg.headers["X-Demo-User"] = u;
  return cfg;
});

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  if (d.code === "NOT_ELIGIBLE") return `Not eligible. Eligible: ${d.eligible.join(", ")}`;
  return d.msg || d.code || JSON.stringify(d);
}

export const logUsage = (body) => api.post("/usage", body).catch(() => {});
